<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="predictor-app">
    <!-- <explore></explore>
    <guide :data="guide" :key="guide.type"></guide> -->
    <!-- EXPLORE-CORE -->
    <!-- <div class="vx-row">
      <div class="vx-col w-full"> -->
        <visualizer :artefact="artefact" :key="artefact.query"></visualizer>
      <!-- </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Explore from "./Explore.vue";
import Guide from "./Guide.vue";
import Visualizer from "./Visualizer.vue";

import { appCommons } from '@/app/shared/services';
import { actionsTypes } from "../shared/state";

export default {
  data() {
    return {
      isNavOpen: false,
      type: "all",
      activeSearch: null,
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      wasSidebarOpen: null,
      payload: {
          tags: [],
          dateRange: [],
          query: "",
          mode: "",
          type: "",
          res: {}
        }
    };
  },
  computed: {
    ...mapGetters({guide: "predictor/guide", artefact: "predictor/artefact", isLoading: "predictor/isLoading"})
  },
  methods: {
    init() {
      // this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_GUIDE, this.payload);
      // this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_ARTEFACT, this.payload);
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#exploreButton",
        // scale: 0.45,
        type: "radius"
      });
      this.explore();
    },
    explore() {
      this.payload = {
        tags: appCommons.currentScopeTagsTemp(),
        dateRange: appCommons.allowedDateScope('', 365, '', ''),
        query: this.flatTags(appCommons.currentScope()),
        mode: "quantity",
        type: "SDF",
        res: {}
      };
      
      this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_ARTEFACT, this.payload);
      this.$store.dispatch('predictor/'+ actionsTypes.FETCH_PREDICTOR_ARTEFACT_UNIT, this.payload);
    },
    flatTags(etags) {
      let i = 0;
      let len = etags.length;
      let flatTags = "";

      for (; i < len; i++) {
        flatTags = flatTags.concat(etags[i].tag + ", ");
      }

      return flatTags.slice(0, -2);
    },
  },
  components: {
    VuePerfectScrollbar,
    Explore,
    Guide,
    Visualizer
  },
  created() {
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.filterReset = true;

    this.$store.watch((state, getters) => getters['predictor/isLoading'],
      (newValue, oldValue) => {
        this.isLoading = newValue;
        if(this.isLoading) {
          // this.exploreLabel = "In Progress ...";
          this.$vs.loading({
            // background: this.backgroundLoading,
            // color: this.colorLoading,
            // container: "#exploreButton",
            // scale: 0.45,
            type: "radius"
          });
        }

        if(!this.isLoading) {
          // this.exploreLabel = "Explore";
          // this.$vs.loading.close("#exploreButton > .con-vs-loading");
          this.$vs.loading.close();
        }
      }
    );   

  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    }
  },
};
</script>